var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "alert-card pa-2 pl-3",
      class: _vm.getAlertCardClass,
      staticStyle: { display: "inline-block", width: "100%", height: "205px" },
      on: { click: _vm.selectCard },
    },
    [
      _c("div", [
        _vm.showHistory
          ? _c("i", {
              staticClass: "far fa-check-circle",
              class: {
                "primary--text":
                  _vm.cardInfo.status == _vm.ALERT_STATUSES.ACKNOWLEDGED,
              },
              staticStyle: {
                "font-size": "17px !important",
                position: "absolute",
                top: "9px",
                right: "4px",
              },
              on: {
                click: function ($event) {
                  _vm.cardInfo.status == _vm.ALERT_STATUSES.UNACKNOWLEDGED
                    ? _vm.$emit("acknowledge", _vm.cardInfo.id)
                    : () => {}
                },
              },
            })
          : _vm._e(),
      ]),
      _c(
        "div",
        { staticStyle: { height: "45px" } },
        [
          _c(
            "v-row",
            { staticClass: "mx-0", attrs: { justify: "space-between" } },
            [
              _c(
                "div",
                { class: _vm.textClass, staticStyle: { "font-size": "15px" } },
                [
                  _c("i", {
                    staticClass: "mr-1 fas fa-exchange-alt primary--text",
                  }),
                  _vm._v(" " + _vm._s(_vm.cardInfo.name) + " "),
                ]
              ),
            ]
          ),
          _c(
            "p",
            {
              staticClass: "mt-2 mb-1",
              staticStyle: {
                "font-size": "0.75rem",
                color: "rgb(160, 160, 0)",
              },
            },
            [_vm._v(" " + _vm._s(_vm.cardInfo.cardDate) + " ")]
          ),
        ],
        1
      ),
      _c(
        "v-row",
        {
          staticClass: "overflowY-auto mx-0 pt-2 mb-1",
          staticStyle: { height: "70px" },
        },
        [
          _vm.triggered
            ? _c(
                "p",
                {
                  staticClass: "mb-0",
                  class: _vm.textClass,
                  staticStyle: { "font-size": "14px" },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.showHistory
                          ? _vm.cardInfo.message
                          : _vm.cardInfo.lastMessage
                      ) +
                      " "
                  ),
                ]
              )
            : _c(
                "p",
                {
                  staticClass: "mb-0",
                  class: _vm.textClass,
                  staticStyle: { "font-size": "14px" },
                },
                [_vm._v(" Alert has not been triggered yet. ")]
              ),
        ]
      ),
      _vm.triggered
        ? _c(
            "v-row",
            {
              staticStyle: { height: "70px" },
              attrs: { justify: "space-between" },
            },
            [
              _c("v-col", { staticClass: "py-0", attrs: { cols: "5" } }, [
                _c(
                  "p",
                  {
                    staticClass: "mt-2 mb-1",
                    class: _vm.textClass,
                    staticStyle: { "font-weight": "300" },
                  },
                  [_vm._v(" Source ")]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "max-height": "40px",
                      "max-width": "116px",
                      "overflow-y": "auto",
                    },
                  },
                  _vm._l(_vm.sourceNames, function (source) {
                    return _c(
                      "p",
                      {
                        key: source,
                        staticClass: "light-text lineHeight1 mb-1",
                        class: _vm.textClass,
                        staticStyle: { "font-size": "12px" },
                      },
                      [_vm._v(" " + _vm._s(source) + " ")]
                    )
                  }),
                  0
                ),
              ]),
              _c(
                "v-col",
                {
                  staticClass: "pa-0 align-self-end",
                  staticStyle: { "font-size": "13px" },
                  attrs: { cols: "7" },
                },
                [
                  !_vm.showHistory
                    ? _c(
                        "p",
                        {
                          staticClass: "lineHeight1 mb-1",
                          staticStyle: {
                            color: "rgb(255, 143, 0)",
                            "font-size": "12px",
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.cardInfo.lastTriggeredHR) + " "
                          ),
                          _c("br"),
                          _vm._v(
                            " Triggered: " +
                              _vm._s(_vm.cardInfo.totalAlerts) +
                              " "
                          ),
                        ]
                      )
                    : _c(
                        "p",
                        {
                          staticClass: "lineHeight1 mb-1",
                          staticStyle: {
                            color: "rgb(255, 143, 0)",
                            "font-size": "12px",
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.cardInfo.createdOnHR) + " ")]
                      ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.showHistory
        ? _c(
            "v-speed-dial",
            {
              staticStyle: {
                position: "absolute !important",
                bottom: "8px !important",
                right: "8px !important",
              },
              attrs: {
                right: "",
                bottom: "",
                direction: "left",
                "open-on-hover": !_vm.isNotDesktop,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function () {
                      return [
                        _c(
                          "v-btn",
                          {
                            staticClass: "small-button-force",
                            attrs: { "x-small": "", fab: "", color: "primary" },
                          },
                          [
                            _c("i", {
                              staticClass: "fas fa-chevron-left",
                              staticStyle: {
                                color: "white",
                                "font-size": "15px",
                              },
                            }),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                2291722761
              ),
            },
            [
              _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on }) {
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                {
                                  staticClass:
                                    "alert-cation mr-1 small-button-force",
                                  class: {
                                    "disabled-alert-cation":
                                      _vm.cardInfo.status ==
                                      _vm.ALERT_STATUSES.ACKNOWLEDGED,
                                  },
                                  attrs: { icon: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.cardInfo.status !=
                                      _vm.ALERT_STATUSES.ACKNOWLEDGED
                                        ? _vm.$emit(
                                            "acknowledge",
                                            _vm.cardInfo.id
                                          )
                                        : 0
                                    },
                                  },
                                },
                                on
                              ),
                              [
                                _c("i", {
                                  staticClass: "far fa-check-circle",
                                  staticStyle: {
                                    color: "white",
                                    "font-size": "17px !important",
                                  },
                                }),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3306258891
                  ),
                },
                [_c("span", [_vm._v("Confirm")])]
              ),
              _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on }) {
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                {
                                  staticClass:
                                    "alert-cation disabled-alert-cation mr-1 small-button-force",
                                  attrs: { icon: "" },
                                },
                                on
                              ),
                              [
                                _c("i", {
                                  staticClass: "fas fa-user-minus ml-1",
                                  staticStyle: {
                                    color: "white",
                                    "font-size": "13px !important",
                                  },
                                }),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2128477292
                  ),
                },
                [_c("span", [_vm._v("Exclude Account")])]
              ),
              _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on }) {
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                {
                                  staticClass:
                                    "alert-cation disabled-alert-cation small-button-force",
                                  attrs: { icon: "" },
                                },
                                on
                              ),
                              [
                                _c("i", {
                                  staticClass: "fas fa-ban",
                                  staticStyle: {
                                    color: "white",
                                    "font-size": "17px !important",
                                  },
                                }),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    4111532619
                  ),
                },
                [_c("span", [_vm._v("Block Trading")])]
              ),
              _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on }) {
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                {
                                  staticClass:
                                    "alert-cation red mr-1 small-button-force",
                                  class: {
                                    "disabled-alert-cation":
                                      _vm.cardInfo.status ==
                                      _vm.ALERT_STATUSES.ACKNOWLEDGED,
                                  },
                                  attrs: { icon: "" },
                                  on: { click: _vm.deleteHistoryCard },
                                },
                                on
                              ),
                              [
                                _c("i", {
                                  staticClass: "fas fa-trash",
                                  staticStyle: {
                                    color: "white",
                                    "font-size": "13px !important",
                                  },
                                }),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1156168911
                  ),
                },
                [_c("span", [_vm._v("Delete")])]
              ),
            ],
            1
          )
        : _vm._e(),
      _c("i", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.showHistory,
            expression: "!showHistory",
          },
        ],
        staticClass: "fas fa-history alert-card-history-icon",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }